import { FC, useState } from 'react';
import ClassStudentList from './StudentList';
import ClassAllocateStudent from './AllocateStudent';
import ClassAllocateResult from './AllocateResult';
import ClassRetire from './Retire';
import ClassTransfer from './Transfer';
import ClassRetireResult from './RetireResult';
import ClassAttendance from './Attendance';
import ClassRefund from './Refund';
import ClassTransferCalculation from './TransferCalculation';

interface IProps {
  tab: string;
  setTab: (tab: string) => void;
  getStudents: (classCode: string) => void;
}

const ClassRegister: FC<IProps> = ({
  tab,
  setTab,
  getStudents,
}) => {
  const [memberCode, setMemberCode] = useState('');
  const [classStudentCode, setClassStudentCode] = useState('');
  const [classCode, setClassCode] = useState('');
  const [timetableCode, setTimetableCode] = useState<number|null>();

  const renderTabContent = () => {
    switch (tab) {
      // 학생 목록
      case 'register':
        return (
          <ClassStudentList
            setTab={setTab}
            memberCode={memberCode}
            setMemberCode={setMemberCode}
            classStudentCode={classStudentCode}
            setClassStudentCode={setClassStudentCode}
          />
        );
      // 학생 배정 (등록)
      case 'allocateStudent':
        return <ClassAllocateStudent setTab={setTab} />;
      // 학생 배정 결과
      case 'allocateResult':
        return <ClassAllocateResult setTab={setTab} />;
      // 학생 출결
      case 'attendance':
        return <ClassAttendance setTab={setTab} />;
      // 인정결석 환불
      case 'refund':
        return <ClassRefund setTab={setTab} tabOrigin="attendance" />;
      // 학생 퇴원
      case 'retire':
        return <ClassRetire setTab={setTab} />;
      // 학생 퇴원 결과
      case 'retireResult':
        return <ClassRetireResult setTab={setTab} />;
      // 학생 전반
      case 'transfer':
        return (
          <ClassTransfer
            setTab={setTab}
            classCode={classCode}
            setClassCode={setClassCode}
            timetableCode={timetableCode}
            setTimetableCode={setTimetableCode}
          />
        );
      // 전반 정산 내역
      case 'transferCalculation':
        return (
          <ClassTransferCalculation
            setTab={setTab}
            memberCode={memberCode}
            classStudentCode={classStudentCode}
            classCode={classCode}
            timetableCode={timetableCode}
            getStudents={getStudents}
          />
        );
    }
  };

  return <>{renderTabContent()}</>;
};

export default ClassRegister;
